export enum EnumTipoEmenda {
    INDIVIDUAL = 1,
    BANCADA = 2,
    COMISSAO = 3,
    RELATOR = 4,
}